module.exports = {
      id: "glyph:question-usage",
      viewBox: "0 0 14 14",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#glyph:question-usage",
      toString: function () {
        return this.url;
      }
    }